<aside class="db-primary-sidebar"
       [ngClass]="{
        'db-with-ph-banner':  sidebarNavigationService.isProductHuntBannerVisible|async,
        'collapsed': isSidebarCollapsed,
        'hidden': isMobile && isSidebarCollapsed,
        'absolute-position': !isMobile && isGlobalPage,
        'has-banner': !!hasGlobalBanner,
        'websites-inner-page': !isGlobalPage
      }"
       (click)="stopEvent($event)">
  <div class="db-primary-sidebar-content">

    <div class="db-primary-menu-items">
      <div class="db-primary-sidebar__header">
          @if (companyInfo) {
              <img [src]="companyInfo?.branding?.cache_icon_big || 'assets/images/logos/logo_placeholder.png'"
                   class="logo"
                   [class.animation]="iconAnimation"
                   [routerLink]="['/websites']"
                   (click)="toggleAnimation()"
              />
          }

        @if (isSidebarCollapsed) {
          <i class="db-icon toggle db-icon-ds-sidebar-show"
             (click)="toggleSidebar()"
             [dsTooltip]="'text_showNavigation' | dbText" dsTooltipPosition="right"
             dsTooltipSize="xs" dsTooltipColor="black" dsTooltipFont="regular"
             [dsTooltipVisible]="!isMobile"></i>
        } @else {
          <span class="sidebar-toggle-wrap">
            <i class="db-icon toggle db-icon-ds-sidebar-hide"
               (click)="toggleSidebar()"
               [dsTooltip]="'text_hideNavigation' | dbText" dsTooltipPosition="right"
               dsTooltipSize="xs" dsTooltipColor="black" dsTooltipFont="regular"
               [dsTooltipVisible]="!isMobile"></i>
          </span>
        }

      </div>

      <div class="db-primary-sidebar__workspaces-wrap" [ngClass]="{'db-collapsed': isSidebarCollapsed}">
        <db-primary-workspace [isCollapsed]="isSidebarCollapsed"
                              [withInviteBlock]="currentWorkspace?.roleId === workspaceRoles.OWNER
           && ((!expiredSubscr && user?.platformClient)
           || (userSubscription?.trialClient && !user?.hostingTrialExpired)
           || userSubscription?.boosterProClient)"
                              [dsTooltip]="'text_switchWorkspace' | dbText" dsTooltipPosition="right"
                              dsTooltipSize="xs" dsTooltipColor="black" dsTooltipFont="regular"
                              [dsTooltipVisible]="!isMobile && isSidebarCollapsed && !(sidebarNavigationService.isWorkspacePopupOpen | async)">
        </db-primary-workspace>
      </div>

        <div class="db-primary-sidebar__menu-items">
            <!-- Websites -->
                <a class="menu-link" [ngClass]="{'active': page === 'websites'}"
                   [dsTooltip]="isSidebarCollapsed ? ('text_sideBarWebsites' | dbText) : ''"
                   dsTooltipPosition="right" dsTooltipSize="xs" dsTooltipFont="regular"
                   dsTooltipColor="black" [dsTooltipVisible]="isSidebarCollapsed && !isMobile"
                   [routerLink]="['/websites']" (click)="page !== 'website' && switchToUserManagement('website')">
                    <i class="db-icon db-icon-ds-websites"></i>
                    <span *ngIf="!isSidebarCollapsed">{{ 'text_sideBarWebsites' | dbText }}</span>
                </a>
        </div>
    </div>

      <div class="db-primary-sidebar__upgrade-section">
          <!--FREE TRIAL -->
          @if (userSubscription?.trialClient && !user?.hostingTrialExpired) {
            <div class="db-trial-box is-this with-popup {{currentWorkspace?.status}}"
                 [ngClass]="{'db-collapsed': isSidebarCollapsed}"
                 [class.show-tooltip]="showFreeTrialTooltip()"
                 (dbClickOutside)="showFreeTrialTooltip() && showFreeTrialTooltip.set(false)"
                 >
              @if (isSidebarCollapsed) {
                <i class="db-icon db-icon-ds-diamond-new"></i>
              } @else {
                <div class="db-trial-box-header" *ngIf="!isSidebarCollapsed">
                  <h4 [innerHTML]="'text_companyFreeTrial' | dbText: {companyName: companyInfo?.branding?.company_name}"></h4>
                  <span class="trial-days" *ngIf="showFreeDaysCount" [innerHTML]="(daysUntilNext > 1 ? 'text_daysLeft_plural' : 'text_daysLeft_singular') | dbText: {days: daysUntilNext}"></span>
                </div>
                <db-progress-bar
                  *ngIf="!isSidebarCollapsed && showFreeDaysCount"
                  [state]="percentageLeft < 30 ? 'danger' : 'black'"
                  [progressPercent]="percentageLeft">
                </db-progress-bar>
                <a class="ds-btn ds-btn-purple-blue ds-btn-max" [routerLink]="['/upgrade-plan']">
                  <span *ngIf="!isSidebarCollapsed">{{ 'text_upgrade' | dbText }}</span>
                  <i *ngIf="isSidebarCollapsed" class="db-icon db-icon-ds-checkmark-bg"></i>
                </a>
              }
                <db-trial-limit-indicator [usedAiCredits]="vibeLimitationData"
                                          [freeDaysCount]="freeDays"
                                          [companyInfo]="companyInfo"
                                          [userSubscription]="userSubscription"
                                          [daysUntilNext]="daysUntilNext"
                                          [percentageLeft]="percentageLeft"
                                          [showFreeDaysCount]="showFreeDaysCount"
                (onUpgrade)="navigateToUpgradePlan()"></db-trial-limit-indicator>
            </div>
          }
          @if (companyInfo?.branding?.contact_email || companyInfo?.branding?.phone_number || companyInfo?.branding?.support_info_message) {
              <a class="ds-btn-white-gray-border db-talk-to-sales-btn" [ngClass]="{'db-collapsed': isSidebarCollapsed}"
                 (click)="showContactPopup = true"
                 [dsTooltip]="isSidebarCollapsed ? ('text_contactSupport' | dbText) : ''" dsTooltipPosition="right" dsTooltipSize="xs"
                 dsTooltipFont="regular" dsTooltipColor="black" [dsTooltipVisible]="isSidebarCollapsed && !isMobile">
                  <i class="db-icon db-icon-ds-tts-micro" [ngClass]="{'db-opened': !isSidebarCollapsed}"></i>
                  <span *ngIf="!isSidebarCollapsed">{{ 'text_contactSupport' | dbText}}</span>
              </a>

              @if (showContactPopup) {
                  <div class="db-contact-support-popup" (dbClickOutside)="showContactPopup = false">
                      <div class="db-contact-support-popup__title">{{ 'text_supportTitle' | dbText }}</div>
                      @if (companyInfo?.branding?.support_info_message) {
                      <div class="db-contact-support-popup__message mb20"
                           [innerHTML]="companyInfo?.branding?.support_info_message || ('text_contactSupportDefault' | dbText)">
                      </div>
                      }
                      @if (companyInfo?.branding?.contact_email || companyInfo?.branding?.phone_number ) {
                          <div class="db-contact-support-popup__contacts">
                              @if (companyInfo?.branding?.contact_email) {
                                  <a [href]="'mailto:' + companyInfo?.branding?.contact_email" class="db-contact-support-popup__contact-item">
                                      <i class="db-icon db-icon-ds-contact-email"></i>
                                      <span>{{ companyInfo?.branding?.contact_email }}</span>
                                  </a>
                              }
                              @if (companyInfo?.branding?.phone_number) {
                                  <a [href]="'tel:' + companyInfo?.branding?.phone_number" class="db-contact-support-popup__contact-item">
                                      <i class="db-icon db-icon-ds-contact-phone"></i>
                                      <span>{{ companyInfo?.branding?.phone_number }}</span>
                                  </a>
                              }
                          </div>
                      }
                      @if (companyInfo?.branding?.whatsapp_number) {
                          <div class="db-contact-support-popup__contact-item whatsapp">
                              <img class="db-whatsapp-image" src="assets/images/icons/whatsapp-icon.svg" />
                              <a [href]="getWhatsAppUrl()" target="_blank">{{'text_chatOnWhatsApp' | dbText}}</a>
                          </div>
                      }
                  </div>
              }
          }
      </div>

  </div>
</aside>

<div class="db-cover-content"
     [ngClass]="{'has-banner': !!hasGlobalBanner}"
     *ngIf="!isSidebarCollapsed && (isMobile || routeData?.hasSecondarySidebar)"
     (click)="toggleSidebar()"></div>
